import {
  Form,
  NumericFormatField,
  SubmitButton,
  TextAreaInputField,
} from '@/components';
import { ActivityFormSchema } from '@/features/project/projects/_models/activity';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof ActivityFormSchema>;

interface Props {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
}

export const ActivityForm: FC<Props> = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(ActivityFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <NumericFormatField
        name="sortOrder"
        label={t('sort-order')}
        hint={t('hint-activity-sort-order')}
        control={control}
        errors={errors}
        allowNegative={false}
        required
      />

      <TextAreaInputField
        name="activityContent"
        label={t('activity-content')}
        hint={t('hint-activity-content')}
        control={control}
        errors={errors}
        rows={3}
        required
      />

      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
